module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Db-Fc.af62173d.png";